import React from 'react';
import { BookOpenIcon, ClipboardListIcon, EyeIcon, GitBranchIcon, TableIcon, UsersIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
const ITEMS = [{
  Icon: BookOpenIcon,
  title: '6 tomos clínicos premium',
  text: 'Un recorrido completo, de la evaluación inicial al manejo de complicaciones. Nunca vuelva a preguntarse: “¿qué hago ahora con este paciente?”.'
}, {
  Icon: ClipboardListIcon,
  title: 'Más de 300 protocolos clínicos',
  text: 'No tendrá que construir un protocolo desde cero. Consulte, decida y continúe con seguridad.'
}, {
  Icon: GitBranchIcon,
  title: 'Algoritmos de decisión clínica',
  text: 'Olvídese de revisar múltiples guías. Cada algoritmo le muestra exactamente qué hacer según la situación del paciente.'
}, {
  Icon: EyeIcon,
  title: 'Guías visuales de interpretación hormonal',
  text: 'Testosterona total y libre, SHBG, LH, FSH, prolactina y estradiol. Sin interpretaciones confusas.'
}, {
  Icon: TableIcon,
  title: 'Tablas de dosificación y selección terapéutica',
  text: 'Compare todas las formulaciones disponibles y seleccione la más adecuada para cada paciente.'
}, {
  Icon: UsersIcon,
  title: 'Protocolos para casos especiales',
  text: 'Obesidad, diabetes, riesgo cardiovascular, alteraciones prostáticas y deseo de preservar la fertilidad.'
}];
export function Included() {
  return <section className="w-full bg-cream-50 py-12 sm:py-16" aria-labelledby="included-title" data-id="element-132" data-mp="2mzhe7chm6cxm">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-133" data-mp="2rtbs1zajfxos">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-134" data-mp="2d34k4di5px2c">
          Todo lo que recibirá hoy
        </p>
        <h2 id="included-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-135" data-mp="2i2h3go9tkm06">
          Una biblioteca clínica que lo acompaña del diagnóstico al largo plazo
        </h2>

        <div className="mt-7 space-y-3.5" data-id="element-136" data-mp="elknhszubr0d">
          {ITEMS.map(item => <article key={item.title} className="flex gap-3.5 rounded-2xl border-l-4 border-gold-500 bg-white p-4 shadow-[0_10px_26px_-22px_rgba(11,32,56,0.6)]" data-id="element-137" data-mp="9ucc4rey9vkk">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy-900" data-id="element-138" data-mp="3w1u2t3zyzlfy">
                <item.Icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-139" data-mp="xkge6uchpn9g" />
              </span>
              <div className="min-w-0" data-id="element-140" data-mp="skbxp4bl0sj8">
                <h3 className="font-display text-[17px] font-bold leading-snug text-navy-900 sm:text-lg" data-id="element-141" data-mp="sld774cy96yu">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-[14px] leading-relaxed text-navy-800/75" data-id="element-142" data-mp="jkov4f749gol">
                  {item.text}
                </p>
              </div>
            </article>)}
        </div>

        <SectionCta label="Quiero tener todo esto en mi consulta" data-id="element-143" data-mp="349uzfwki1gda" />
      </div>
    </section>;
}